module.exports = new __parcel__URL__("star_laboratory_level_2.4c125025.png").toString();